/* FRONT PAGE SCRIPTS */

jQuery(document).ready(function($) {	
	initOffCanvasSwitcher();	
	initNavigation();
	
	jQuery('ul>li.has-multiple-dropdowns').on("mouseover", () => {
		navMenuAdjust(event);
	});
});

var currentTransition = "",
currentPosition = "";

function initNavigation() {
	jQuery('.sticky-wrapper-navigation').on('sticky.zf.stuckto:top', function(){
		  jQuery(this).addClass('shrink');
	}).on('sticky.zf.unstuckfrom:top', function(){
		  jQuery(this).removeClass('shrink');
	})	
}

function navMenuAdjust(event) {
	   
	setTimeout( () => {
		
		   jQuery('li.has-multiple-dropdowns ul.is-dropdown-submenu').css('height', 'auto');
		   jQuery('li.has-multiple-dropdowns ul.is-dropdown-submenu.menu-depth-2').css('height', '100%');
		
		let heightArray = [];
	  
		if(jQuery(event.target).closest('ul.is-dropdown-submenu').hasClass('menu-depth-1')) {
			let depth1Height = jQuery(event.target).closest('ul.is-dropdown-submenu').outerHeight();
			let depth2Height = jQuery(event.target).siblings('ul.is-dropdown-submenu').outerHeight();
			if(depth2Height === undefined) {
				depth2Height = 0;
			}
			heightArray.push(depth1Height, depth2Height);
		}
	
		else if(jQuery(event.target).closest('ul.is-dropdown-submenu').hasClass('menu-depth-2')) {
			let depth1Height = jQuery(event.target).closest('ul.is-dropdown-submenu').parents('ul.is-dropdown-submenu').outerHeight();
			let depth2Height = jQuery(event.target).closest('ul.is-dropdown-submenu').outerHeight();
			let depth3Height = jQuery(event.target).siblings('ul.is-dropdown-submenu').outerHeight();
			if(depth3Height === undefined) {
				depth3Height = 0;
			}
			heightArray.push(depth1Height, depth2Height, depth3Height);
		}
		else if (jQuery(event.target).closest('ul.is-dropdown-submenu').hasClass('menu-depth-3')) {
			let depth1Height = jQuery(event.target).closest('ul.is-dropdown-submenu').parents('ul.is-dropdown-submenu').parents('ul.is-dropdown-submenu').outerHeight();
			let depth2Height = jQuery(event.target).closest('ul.is-dropdown-submenu').parents('ul.is-dropdown-submenu').outerHeight();
			let depth3Height = jQuery(event.target).closest('ul.is-dropdown-submenu').outerHeight();
			heightArray.push(depth1Height, depth3Height, depth2Height)
		}
		
		if(heightArray.length > 0) {
			heightArray.sort((a,b) => {
				return b-a
			});
			
		}
		
		let resizeHeight = heightArray[0]+32;
		
		if(resizeHeight !== 0) {   
			   jQuery('li.has-multiple-dropdowns ul.is-dropdown-submenu').height(`${resizeHeight}px`);
		}	            
		
	}, 160)
 }

function initOffCanvasSwitcher() {

	jQuery(window).on("load",function(e){
		var newSize = Foundation.MediaQuery.current;		
		setOffcanvasPosition(newSize);		
	});	
		
	jQuery(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
		// newSize is the name of the now-current breakpoint, oldSize is the previous breakpoint		 
		setOffcanvasPosition(newSize);		  
	});
	
	function setOffcanvasPosition(newSize) {		
		var mobileOffcanvas = jQuery('#off-canvas').data("mobile").split(" "),
		tabletOffcanvas = jQuery('#off-canvas').data("tablet").split(" "),
		offCanvas = jQuery('#off-canvas');
				
		if(newSize == 'xmedium' || newSize == 'medium'){		
			offCanvas.removeClass("position-"+mobileOffcanvas[0]).addClass("position-"+tabletOffcanvas[0]);
			offCanvas.removeClass("is-transition-"+mobileOffcanvas[1]).attr("data-transition", tabletOffcanvas[1]).addClass("is-transition-"+tabletOffcanvas[1]);			
			currentPosition = tabletOffcanvas[0];	
			currentTransition = tabletOffcanvas[1];					
		} 
		
		if(newSize == 'smedium' || newSize == 'small' || newSize == 'xsmall'){		
			offCanvas.removeClass("position-"+tabletOffcanvas[0]).addClass("position-"+mobileOffcanvas[0]);	
			offCanvas.removeClass("is-transition-"+tabletOffcanvas[1]).attr("data-transition", mobileOffcanvas[1]).addClass("is-transition-"+mobileOffcanvas[1]);			
			currentPosition	 = mobileOffcanvas[0];
			currentTransition = mobileOffcanvas[1];					
		}  
	}
		
	// ADDS class name to the body tag to disable scrolling when the offcanvas menu is open and adding transition and positioning class names
	jQuery('#off-canvas').on('opened.zf.offCanvas', function () {
		jQuery("body").addClass('offCanvasOpen');
		var navFixedState = Foundation.MediaQuery.is('xmedium down'),		
		hasIsAnchored = jQuery('.sticky-wrapper-navigation').hasClass('is-anchored');
		
		if(navFixedState && hasIsAnchored ){ jQuery('.sticky-wrapper-navigation').removeClass('is-anchored').addClass('is-stuck');}    
	
		jQuery(".hamburger").addClass("is-active");             
		jQuery('.off-canvas-content').removeClass('is-opened is-open-left has-position-left has-transition-push has-transition-overlap').addClass('is-opened is-open-'+currentPosition+' has-position-'+currentPosition+' has-transition-'+currentTransition);   		
	});
   
	jQuery('#off-canvas').on('close.zf.offCanvas', function () {
		// Look for .hamburger
		jQuery(".hamburger").removeClass("is-active");
		jQuery("body").removeClass('offCanvasOpen');
		jQuery('.off-canvas-content').removeClass('is-opened is-open-'+currentPosition+' has-position-'+currentPosition);  
	});
}